module.exports = __webpack_public_path__ + "static/7-4df4693f8f671beb7b898b3f6505f5bd.png";